/**
 * @desc 全量获取类目
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/category/plm/fullAmountUpdateCategory`, {
      method: "GET",

      ...options,
    }),
  );
}
